import React from 'react';

var SvgTeamIcon = function SvgTeamIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 4a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Zm-.75 2.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 7a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Zm-.75 2.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.75 6.25a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Zm2.25-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9a.75.75 0 0 0 0 1.5h.75c.69 0 1.25.56 1.25 1.25v1.5a.75.75 0 0 0 1.5 0v-1.5a2.75 2.75 0 0 0-2.75-2.75h-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9.75a.75.75 0 0 0-.75-.75h-.75a2.75 2.75 0 0 0-2.75 2.75v1.5a.75.75 0 0 0 1.5 0v-1.5c0-.69.56-1.25 1.25-1.25h.75a.75.75 0 0 0 .75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 12a2.75 2.75 0 0 1 2.75 2.75v1a.75.75 0 0 1-1.5 0v-1c0-.69-.56-1.25-1.25-1.25h-1.5c-.69 0-1.25.56-1.25 1.25v1a.75.75 0 0 1-1.5 0v-1a2.75 2.75 0 0 1 2.75-2.75h1.5Z"
  }));
};
SvgTeamIcon.displayName = "TeamIcon";

export { SvgTeamIcon as S };
